import React from 'react';

// project-import
import StencilBox from '../stencils/StencilBox';

const LoginFormStencil = () => {
    return (
        <div className="login-form-box">
            <h3 className="mb-30">
                <StencilBox
                    width="100%"
                    height="60px"
                    backgroundColor="#F5F5F5"
                    border="none"
                />
            </h3>
            <form className="login-form" action="">
                <div className="input-box mb--30">
                    <StencilBox
                        width="100%"
                        height="60px"
                        backgroundColor="#F5F5F5"
                        border="none"
                    />
                </div>
                <div className="input-box mb--30">
                    <StencilBox
                        width="100%"
                        height="60px"
                        backgroundColor="#F5F5F5"
                        border="none"
                    />
                </div>
                <div className="comment-form-consent input-box mb--30">
                    <StencilBox
                        width="100%"
                        height="26px"
                        backgroundColor="#F5F5F5"
                        border="none"
                    />
                </div>

                {/* Adding Spinner icon Start Here */}
                <StencilBox
                    width="100%"
                    height="60px"
                    backgroundColor="#F5F5F5"
                    border="none"
                />
                <div className="input-box">
                    {/* <a href="#" className="lost-password">Lost your password?</a> */}
                </div>
            </form>
        </div>
    )
}

export default LoginFormStencil;